module.exports = __webpack_public_path__ + "static/media/ecommerce-768x278.b16f5157.jpg";